import { ChangeDetectionStrategy, Component, Injector, OnInit } from '@angular/core';
import { Question, Questions } from 'models';
import { BaseComponent } from 'src/_base/base/base.component';
import { DirectSearchService, SurveyService } from 'src/_services';
import { StorageService } from 'src/_services/storage.service';
import { TotalsService } from 'src/_services/totals.service';
import { SurveyUtility } from 'src/_utility/survey';
import { TotalsUtility } from 'utility';
import { SidePanelService } from '../side-panel.service';
import { SidePanelPages } from 'src/_models/panels';

@Component({
  selector: 'app-side-panel-products',
  templateUrl: './side-panel-products.component.html',
  styleUrl: './side-panel-products.component.css'
})
export class SidePanelProductsComponent extends BaseComponent implements OnInit {

  page: SidePanelPages = SidePanelPages.DEFAULT;

  nProducts: number = undefined
  totalProducts: number = undefined;

  isTotalProductsLoading: boolean = false;

  constructor(
    private inj: Injector,
    private sidePanel: SidePanelService,
    private storage: StorageService,
    private totals: TotalsService,
    private survey: SurveyService,
    private directSearch: DirectSearchService,
  ) {
    super(inj);
  }

  ngOnInit(): void {
    this.getTotalProducts();
    this.subTotalsOnLoaded();
    this.subDirectSearchOnLoaded();
    this.subPageOnChange();

    
  }

  // #region "Subscriptions"

  subPageOnChange() {
    const pageOnChangeSub = this.sidePanel.onPageChange.subscribe({
      next: data => {
        this.page = data;
        this.nProducts = null;
      }
    });
    this.addSubscription(pageOnChangeSub);
  }

  subTotalsOnLoaded() {
    const totalsOnLoadedSub = this.totals.totalsOnLoaded.subscribe({
      next: (data) => {
        const questions = this.survey.getQuestions();
        // const lastQAnswered: Question = SurveyUtility.getLastQuestionToAnswer(questions).prevQuestion;
        const lastQAnswered: Question = SurveyUtility.getLastQuestionWithAnswer(questions);
        if (lastQAnswered) { 
          const lastAnswer = SurveyUtility.getSelectedAnswerOfQuestion(lastQAnswered);
          if (lastAnswer) { this.nProducts = this.totals.getTotal(lastAnswer.id)?.quantity ?? undefined }
        }

        this.isTotalProductsLoading = false;
      },
      error: (err) => {
        this.isTotalProductsLoading = false;
      }
    })
    this.addSubscription(totalsOnLoadedSub);
  }

  subDirectSearchOnLoaded() {
    const directSearchOnLoadedSub = this.directSearch.onSearchLoaded.subscribe({
      next: data => {
        this.nProducts = data?.length ?? undefined;
      }
    });
    this.addSubscription(directSearchOnLoadedSub);
  }

  // #endregion "Subscriptions"

  // #region "Get total products"

  getTotalProducts() {
    this.isTotalProductsLoading = true;
    this.totalProducts = this.storage.getTotalProducts();
    if (this.totalProducts == undefined) { this.loadTotalProducts(); }
    else {
      this.isTotalProductsLoading = false;
    }
  }

  loadTotalProducts()  {
    const input = TotalsUtility.getTotalInput(null);
    this.totals.loadTotals(input, this.getTotalProducts.bind(this));

  }

  // #endregion "Get total products"



}